// 图片cdn地址
export const IMG_CDN_SITE = "//j1.58cdn.com.cn/jinrong/images/";
export const IMG_CDN_WOS = "//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/";

export const MY_HELP_HREF =
    "//daikuan.58.com/wap/aiqa/daikuan/#/entry/business_type=58haojie&joinfrom=jq-usercenter&client_type=app";
export const CUSTOMER_IMG =
    "https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/i6cceqc2__w112_h112.png";

// 业务id
export const BIZ_ID = "100102006";
export const BIZ_ID_AB = "100102008"; // ab测的业务id

// 资方
export const ZHONG_YIN = "fcode_bank_of_china";
export const JU_DUO_DUO = "fcode_com_juzi"; // 桔多多
export const ZHONG_GUAN_CUN = "fcode_bank_zgc";
export const ZHONG_BANG = "fcode_bank_zbank02";
export const LAN_HAI = "fcode_bank_blueocean";
export const XIAO_DAI = "fcode_loan_wb";
export const LAN_ZHOU = "fcode_bank_lz"; // 兰州银行
export const LANG_FANG = "fcode_insure_gr"; // 廊坊银行（国任保险）
export const JUZI_CHANG_YIN = "fcode_com_changyin"; //长安银行
export const XIN_YONG_FEI = "XIN_YONG_FEI"; // 信用飞
export const XIAO_YING = '30028'; // 小赢
export const YANG_QIAN_GUAN = '30032'; // 洋钱罐
export const WO_LAI_DAI = '30036'; // 我来贷
export const XIAO_HUA_QIAN_BAO = '30041'; // 小花钱包
export const DOU_DOU_QIAN = '30042'; // 豆豆钱
export const SHI_GUANG_FEN_QI = '30044'; // 时光分期
export const ZHONG_YUAN_XIAO_JIN = '30018'; // 中原消金
export const DU_XIAO_MAN = '30016'; // 度小满
export const CE_SHI_ONE = '30019'; // 测试1
export const CE_SHI_TWO = '30020'; // 测试2

// 首页机构展示全集 桔多多、信用飞、洋钱罐、豆豆钱、我来贷、小赢卡贷、小花钱包、时光分期、恒小花
export const ALL_FOUNDS_Map = {
    [JU_DUO_DUO]: '桔多多',
    [XIN_YONG_FEI]: '信用飞',
    [YANG_QIAN_GUAN]: '洋钱罐',
    [DOU_DOU_QIAN]: '豆豆钱',
    [WO_LAI_DAI]: '我来贷',
    [XIAO_YING]: '小赢卡贷',
    [XIAO_HUA_QIAN_BAO]: '小花钱包',
    [SHI_GUANG_FEN_QI]: '时光分期',
    [ZHONG_YUAN_XIAO_JIN]: '中原消金',
    [DU_XIAO_MAN]: '度小满',
    [CE_SHI_ONE]: '测试1',
    [CE_SHI_TWO]: '测试2'
};


//支持无卡号绑卡资方
export const supportNoNumberBindCardFunds = [
    LAN_HAI,
    XIAO_DAI
];

//快借机构
export const isKJPartners = [
    XIN_YONG_FEI,
    XIAO_YING,
    YANG_QIAN_GUAN,
    WO_LAI_DAI,
    XIAO_HUA_QIAN_BAO,
    DOU_DOU_QIAN,
    SHI_GUANG_FEN_QI,
    ZHONG_YUAN_XIAO_JIN,
    DU_XIAO_MAN,
    CE_SHI_ONE,
    CE_SHI_TWO,
];

// 长银, 小赢不支持还款时绑新卡  故不展示该入口；
export const notRepaymentBindCardFunds = [JUZI_CHANG_YIN];

// 长银，中银资方还款通过 API 方式，虚拟收银台还款
export const apiRepaymentFundCode = [
    ZHONG_YIN, 
    JUZI_CHANG_YIN,
    XIN_YONG_FEI, 
    YANG_QIAN_GUAN, 
    DOU_DOU_QIAN, 
    WO_LAI_DAI, 
    XIAO_YING, 
    XIAO_HUA_QIAN_BAO, 
    SHI_GUANG_FEN_QI, 
    ZHONG_YUAN_XIAO_JIN, 
    DU_XIAO_MAN, 
    CE_SHI_ONE, 
    CE_SHI_TWO
];

// 银行默认logo
export const BANK_LOGO_DEFAULT = `${IMG_CDN_WOS}5gc57iva.png`;

// 类型 标识是提现页还是增验页的返回操作导致的挽留弹窗
export const typeMap = {
    1: "提现页面跳转",
    2: "增验页面跳转",
    3: "未填写借款金额且客户有可用优惠券挽留弹窗",
    4: "未填写借款金额且客户发生降价挽留弹窗",
    5: "已填写借款金额且客户未绑卡且当前资方支持免卡号绑卡挽留弹窗",
    6: "已填写借款金额且客户未绑卡且当前资方不支持免卡号绑卡挽留弹窗",
    7: "新增验流程挽留弹窗",
};

export const TXMD_IS_PICK_TERM = "txmdIsPickTerm";
export const TXMD_IS_SEE_PLAN = "txmdIsSeePlan";
export const TXMD_IS_CASH_ALL = "txmdIsCashAll";

// 购买会员卡标示
export const BUY_VIP_STATUS = "buyVipStatus";
// 购买资金匹配卡标示
export const BUY_FUND_MATCH_STATUS = "buyFundMatchStatus";

//新客免息挽留弹框埋点
export const retaintWmda = {
    showRetentionWmda: {
        event_id: "1011",
        event_name: "展现_新客挽留弹窗",
    },
    clickConfirmWmda: {
        "data-event-id": "1012",
        "data-custom-click": "点击_新客挽留弹窗_继续借钱",
    },
    clickCancelWmda: {
        "data-event-id": "1013",
        "data-custom-click": "点击_新客挽留弹窗_残忍退出",
    },
};
